<template>
  <div class="progressParent">
    <div class="out-progress">
      <div class="progress">
        <span
          class="progress-item1"
          v-bind:style="{ width: orderFinishCount() }"
        ></span>
      </div>
      <div class="progress-item2">{{ orderFinishCount() }}</div>
    </div>
  </div>
</template>

<script>
import { formatElementPerc } from '@/common/util';
export default {
  name: 'progress-item',
  props: ['scope'],
  data() {
    return {
      percent: '',
    };
  },
  methods: {
    orderFinishCount() {
      if (this.scope.row.orderCount == 0) {
        this.percent = 0;
        return 0 + '%';
      }
      this.percent =
        formatElementPerc(
          (this.scope.row.orderFinishCount / this.scope.row.orderCount) * 100
        ) + '%';
      return this.percent;
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style scoped lang="scss">
.out-progress {
  display: flex;
  align-items: center;
}
.progress {
  height: 18px;
  width: 70%;
  background: #f9f9f9;
  border-radius: 50px;
  position: relative;
}
.progress-item1 {
  height: 18px;
  background: #3da1ff;
  border-radius: 50px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.progress-item2 {
  margin-left: auto;
  color: #3da1ff;
  font-size: 18px;
}
</style>
